// src/pages/VisaRequirements.jsx
import React from "react";
import VisaRequirementsPage from "../../components/VisaRequirementsPage/VisaRequirementsPage"; // الكود اللي عملناه قبل كده

export default function VisaRequirements() {
  return (
    <div style={{ direction: "rtl" }}>
      <VisaRequirementsPage/>
    </div>
  );
}
